import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

type RequestTester = ((request: HttpRequest<any>) => boolean) | RegExp | string;

interface CacheRecord {
  tester: RequestTester;
  ttl?: number;
  response?: HttpResponse<any>;
  timestamp?: number;
}

@Injectable()
export class CacheService {
  private readonly cache: CacheRecord[] = [];

  public setCacheable(tester: RequestTester, ttl?: number): void {
    this.cache.push({ tester, ttl });
  }

  public isCacheable(request: HttpRequest<any>): boolean {
    return !!this.getCacheRecord(request);
  }

  public getCache(request: HttpRequest<any>): HttpResponse<any> | undefined {
    const record = this.getCacheRecord(request);
    if (record && record.response) {
      const now = Date.now();
      if (!record.ttl || record.ttl >= now - record.timestamp) {
        return record.response;
      }
    }
  }

  public putCache(request: HttpRequest<any>, response: HttpResponse<any>): void {
    const record = this.getCacheRecord(request);
    if (record) {
      record.response = response;
      record.timestamp = Date.now();
    }
  }

  private getCacheRecord(request: HttpRequest<any>): CacheRecord | undefined {
    for (const record of this.cache) {
      if (this.testRequest(request, record.tester)) {
        return record;
      }
    }
  }

  private testRequest(request: HttpRequest<any>, tester: RequestTester): boolean {
    if (tester instanceof RegExp) {
      return request.method === 'GET' && tester.test(request.urlWithParams);
    }
    if (typeof tester === 'string') {
      return request.method === 'GET' && tester === request.urlWithParams;
    }
    return tester(request);
  }
}
